import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {
    buildMySamplesSectionPath,
    CUSTOMER_GROUPS_SUBMENU_BREADCRUMB,
} from "../../../../utils/customerBreadcrumbLabels";
import React, {useEffect, useMemo, useState} from "react";
import Box from "@mui/material/Box";
import ButtonCreate, {buttonCreateAutoSizeSx, customerPageHeaderRowSx} from "../../../../components/UI/button/ButtonCreate";
import GroupMaterialUtil from "../../../../utils/orders/GroupMaterialUtil"
import AddGroupModal from "./AddGroupModal";
import {
    MaterialReactTable,
    MRT_BottomToolbar, MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {constantsErrorMessages} from "../../../../Constants";
import SamplesControllerServiceGroupAdmin from "../../../../API/samples/Admin/SamplesGroupAdmin";
import SamplesControllerServiceGroup from "../../../../API/samples/Customers/SamplesGroup";
import {Typography} from "@mui/material";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";

const SamplesGroups = ({system, settings}) => {
    const [alertData, setAlertData] = useState({});
    const [change, setChange] = useState(false)
    const [groupMap, setGroupMap] = useState(null);
    const [filterGroup, setFilterGroup] = useState(new Map());
    const [changeFilterGroup, setChangeFilterGroup] = useState(false);

    const rowInitValue = {name: "", currentGroup: null}
    const [data, setData] = useState([]);
    const [dataTree, setDataTree] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    const [currentEditRowData, setCurrentEditRowData] = useState(rowInitValue);
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [isNew, setIsNew] = useState(true);

    const [modalOpen, setModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const api = system ? SamplesControllerServiceGroupAdmin : SamplesControllerServiceGroup
        api.getAll().then((response) => {
            setData(response.data);
            const buildTreeGroups = GroupMaterialUtil.buildTreeGroupsSamples(response.data);
            setDataTree(buildTreeGroups)
            const groupMap = new Map();
            GroupMaterialUtil.addToMap(buildTreeGroups, groupMap)
            setGroupMap(groupMap);
            // setCurrentGroup({})
        }).catch(function (error) {
            handleModalAlert(error)
        });
    }, [change]);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleClose = () => {
        setModalOpen(false)
        setCurrentEditRowData(rowInitValue)
        setIsNew(true)
    }
    const handleEditGroup = (row) => {
        setCurrentEditRowData({name: row.name, currentGroup: row.parentGroup || {}})
        setCurrentEditRowId(row.id);
        setIsNew(false);
        setModalOpen(true)
    };

    const handleAddGroup = (data) => {
        setLoading(true)
        const api = system ? SamplesControllerServiceGroupAdmin : SamplesControllerServiceGroup
        api.save(data).then(() => {
            setChange(!change)
            handleClose()
            handleModalAlert("Данные добавлены", 'success')
        }).catch(function (error) {
            handleModalAlert(error)
        })
            .finally(() => setLoading(false))
    }

    const handleUpdate = (data) => {
        setLoading(true)
        const api = system ? SamplesControllerServiceGroupAdmin : SamplesControllerServiceGroup
        api.edit(currentEditRowId, data)
            .then(function (response) {
                setChange(!change)
                handleClose()
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleDeleteGroup = (row) => {
        const api = system ? SamplesControllerServiceGroupAdmin : SamplesControllerServiceGroup
        api.delete(row.id)
            .then(function () {
                setChange(!change)
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };
    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование',
                accessorKey: 'name',
                minSize: 600
            },
            {
                header: 'Родительская группа', accessorKey: 'parentGroup.name', minSize: 600,
                Cell: ({cell}) => {
                    {
                        return cell.getValue() || "Группа является корневой"
                    }
                }
            },
        ]
        return baseColumns;
    }, [data]);


    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEditGroup},
        {type: "delete", text: "Удалить", handler: handleDeleteGroup}
    ]

    return <Box sx={{
        padding: settings ? 0 : "0 30px",
        overflow: 'auto',
        maxWidth: settings ? 'calc(100vw - 410px)' : "100vw",
    }}>
        {!settings && <BreadcrumbsComponent
            page={CUSTOMER_GROUPS_SUBMENU_BREADCRUMB.name}
            path={buildMySamplesSectionPath()}
        />}
        <Box sx={customerPageHeaderRowSx}>
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>Группы</Typography>
            <ButtonCreate
                onClick={() => setModalOpen(true)}
                text={"Cоздать группу"}
                width="auto"
                height="auto"
                sx={buttonCreateAutoSizeSx}
            />
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            selectAllMode={"all"}
            muiTableContainerProps={{
                sx: {
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "100%",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
                'mrt-row-expand': {
                    size: 3,
                    minSize: 3,
                    grow: false,
                }
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={dataTree}
            rowHeight={13}
            columnSpacing={1}
            paginateExpandedRows={false}
            onRowSelectionChange={setRowSelection}
            state={{rowSelection, showGlobalFilter: true}}
            getRowId={(originalRow) => originalRow.id}
            enableExpanding={true}
            getSubRows={(originalRow) => originalRow.subGroups}
            selectionPadding={1}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderBottomToolbar={({table}) => {
                const tableProps = {
                    ...table,
                    options: {
                        ...table.options,
                        localization: {
                            ...table.options.localization,
                            rowsPerPage: `Всего строк: ${data.length}. Сгруппированных элементов на странице:`
                        }
                    }
                }
                return <MRT_BottomToolbar table={tableProps}/>
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}

        />
        <AddGroupModal
            title={isNew ? "Добавить группу" : "Изменить группу"}
            buttonText={isNew ? "Добавить" : "Изменить"}
            dataTree={dataTree}
            groupMap={groupMap}
            open={modalOpen}
            onSubmit={isNew ? handleAddGroup : handleUpdate}
            onClose={handleClose}
            filterGroup={filterGroup}
            setFilterGroup={setFilterGroup}
            changeFilterGroup={changeFilterGroup}
            setChangeFilterGroup={setChangeFilterGroup}
            initValue={currentEditRowData}
            loading={loading}>
        </AddGroupModal>
        <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
            return {...alert, open: false}
        })}/>
    </Box>
}
export default SamplesGroups